<template>
  <div id="monitoramentoFotosTeoricas">
    <vuestic-modal ref="modalPhotos" id="modalPhotos" v-bind:large="true" :cancelClass="'none'" :okClass="'none'">
      <div class="row" v-if="selectedUser.presencas && selectedUser.fotos">
        <div class="col-md-12 mb-3 d-flex">
          <div class="col-md-3">
            <strong class="font-weight-bold">Instrutor/Aluno</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ selectedUser.participante }}</span>
          </div>
          <div class="col-md-3">
            <strong class="font-weight-bold">ENTRADA</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ selectedUser.presencas.find(element => element.tipo == 0) ?
                                                                            selectedUser.presencas.find(element => element.tipo == 0).created_at.split(" ")[1] :
                                                                            'Entrada não registrada' }}
            </span>
          </div>
          <div class="col-md-3">
            <strong class="font-weight-bold">INTERVALO</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ selectedUser.presencas.find(element => element.tipo == 2) ?
                                                                            selectedUser.presencas.find(element => element.tipo == 2).created_at.split(" ")[1] :
                                                                            'Intervalo não registrado' }}
            </span>
          </div>
          <div class="col-md-3">
            <strong class="font-weight-bold">SAÍDA</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ selectedUser.presencas.find(element => element.tipo == 1) ?
                                                                            selectedUser.presencas.find(element => element.tipo == 1).created_at.split(" ")[1] :
                                                                            'Saída não registrada' }}
            </span>
          </div>
        </div>
        <div class="col-md-12 mb-3 d-flex">
          <!-- <div class="col-md-6">
            <strong class="font-weight-bold">Monitor</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.nome }}</span>
          </div> -->
          <!-- <div class="col-md-3">
            <strong class="font-weight-bold">Primeiro registro</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.inicio | DateBRFilter }}</span>
          </div> -->
          <!-- <div class="col-md-3">
            <strong class="font-weight-bold">Ultimo registro</strong>
            <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.fim | DateBRFilter }}</span>
          </div> -->
        </div>
        <div class="col-md-12 d-flex">
          <div class="col-md-7 mt-3 text-center">
            <div style="max-height: 400px; overflow: auto">
              <span class="mr-1 ml-1 text-center" v-for="(user, index) in selectedUser.fotos" :key="index">
                <img class="img-thumbnail mt-2 mb-2"
                  style="width: 160px; height: 160px; cursor: pointer"
                  :src="'data:image/jpeg;base64, ' + user.imagem" :title="user.tempo.split(' ')[1]"
                  alt="Falha ao carregar imagem">
              </span>
            </div>
            <div style="display: flex" class="mt-3">
              <div class="col-md-6">
              </div>
              <div class="col-md-6 text-right">
                <span class="badge bg-secondary">{{ selectedUser.fotos.length }}</span>
              </div>
            </div>
            <hr>
            <!-- <button type="button" class="btn btn-lg btn-block btn-primary"
            :disabled="!selectedUser.presencas.find(element => element.tipo == 0) || btnNotificacao"
            @click="sendMonitoring(selectedUser, selectedUser.presencas.find(element => element.tipo == 0).entidade)" title="Registrar monitoria">MONITORANDO</button> -->
          </div>
          <div class="col-md-5 text-center">
            <span>
                  <img class="img-thumbnail mt-2 mb-2" style="width: auto; height: 400px" :src="'data:image/jpeg;base64, ' + selectedUser.perfil">
            </span>
            <!-- <div id="acoes" class="mt-3"> -->

              <!-- IMAGEM COM ERRO -->

              <!-- <select class="form-control mb-2" v-model="idNotificacao">
                <option disabled selected>Selecione uma notificação</option>
                <option v-for="notificacao in notificacoes" :value="notificacao.value" :key="notificacao.value">{{ notificacao.title }}</option>
              </select>
              <span class="mr-2 btn-lg btn-block btn-primary"
                :disabled="!selectedUser.presencas.find(element => element.tipo == 0)"
                title="Notificar aluno"
                @click="notificarAluno(selectedUser.cpf)">
                <a>
                  <i class="fa fa-bell"></i>
                </a>
              </span>
            </div> -->
          </div>
        </div>
      </div>
    </vuestic-modal>
    <vuestic-modal ref="modalReport" id="modalReport" v-bind:large="true" :cancelClass="'none'" :okClass="'none'">
      <span slot="title">Reportar Problema</span>
      <div class="col-md-12 mb-3 d-flex">
        <div class="col-md-6">
          <strong class="font-weight-bold">Monitor</strong>
          <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.nome }}</span>
        </div>
        <div class="col-md-3">
          <strong class="font-weight-bold">Primeiro registro</strong>
          <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.inicio | DateBRFilter }}</span>
        </div>
        <div class="col-md-3">
          <strong class="font-weight-bold">Ultimo registro</strong>
          <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.fim | DateBRFilter }}</span>
        </div>
      </div>
      <div class="container text-center">
        <div class="row">
          <div class="col-sm">
            {{ report.participante ? report.participante : report.autoescola }}
          </div>
          <div class="col-sm">
            {{ report.agrupamento }}
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-sm">
            <input class="form-check-input" id="semRosto" type="radio" name="problem" value=2 v-model="report.tipo_report">
            <label class="form-check-label" for="semRosto">
              Candidato ou instrutor não está presente nas fotos.
            </label>
          </div>
          <div class="col-sm">
            <input class="form-check-input" id="invalida" type="radio" name="problem" value=3 v-model="report.tipo_report">
            <label class="form-check-label" for="invalida">
              Fotos ilegíveis (ex:escuras ou que impossibilitem o reconhecimento facial).
            </label>
          </div>
          <div class="col-sm">
            <input class="form-check-input" id="impropria" type="radio" name="problem" value=4 v-model="report.tipo_report">
            <label class="form-check-label" for="impropria">
              Registro de fotos impróprias ou de cunho sexual.
            </label>
          </div>
          <div class="col-sm">
            <input class="form-check-input" id="semFoto" type="radio" name="problem" value=5 v-model="report.tipo_report">
            <label class="form-check-label" for="semFoto">
              Sem fotos registradas.
            </label>
          </div>
        </div>
        <hr>
        <div class="row">
          <legend>Informe que atitude foi tomada</legend>
          <textarea class="form-control card" placeholder="Atitudes tomadas (limite de 255 caracteres)" maxlength="255" v-model="report.observacao"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <button type="button" class='btn btn-danger btn-block btn-lg'
            :disabled="btnNotificacao" @click="sendReport(report)">
            ENVIAR
          </button>
        </slot>
      </div>
    </vuestic-modal>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget headerText="Monitoramento das Aulas Teóricas">
          <div class="text-center">
            <h1 id="clock"></h1>
          </div>
          <div class="row">
            <model-select
              class="col-md-4 mb-2 ml-3"
              :options="selectCFC"
              v-model="selectedCFC"
              placeholder="Selecione uma Autoescola"
            ></model-select>

            <model-select
              class="col-md-4 mb-2 ml-3"
              :options="selectPeriodo"
              id="periodo"
              v-model="selectedPeriodo"
              placeholder="Selecione o Período"
            ></model-select>
            <button class="btn btn-info btn-micro col-md-3 mb-2 ml-3" @click="loadData()" :disabled="loadTable">
              <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
              <span class="font-button-modified">Consultar</span>
            </button>
          </div>

          <div v-if="loadTable" class="d-flex justify-content-center">
            <component
              :animation-duration="1000"
              :is="'SpringSpinner'"
              :color="'#4AE387'"
              :size="80"
            >
            </component>
          </div>

          <div v-else class="row text-center">
            <div class="col-12" v-if="tbTurmas.length > 0">
              <table>
                <thead>
                  <tr>
                    <th>Agrupamento</th>
                    <th>Inicio</th>
                    <th>Fim</th>
                    <th>Alunos Regulares</th>
                    <th>Alunos de Reposição</th>
                    <th>Alunos Presentes</th>
                  </tr>
                </thead>
                <tbody v-for="turma in tbTurmas" :key="turma.id_turma_teorica">
                  <tr>
                    <td>{{ turma.id_agrupamento }}</td>
                    <td>{{ turma.data_inicio.split(" ")[1] | DateBRFilter }}</td>
                    <td>{{ turma.data_fim.split(" ")[1] | DateBRFilter }}</td>
                    <td>{{ turma.quantidade_alunos }}</td>
                    <td>{{ turma.reposicao_alunos.length }}</td>
                    <td>
                      {{
                        turma.quantidade_alunos_presentes === null
                          ? "Sem presença de aluno registrada"
                          : turma.quantidade_alunos_presentes
                      }}
                    </td>
                    <td>
                      <button type="button" class="btn btn-lg btn-block btn-primary" :disabled="loadingPhotos" @click="loadPhotos(turma.id_turma_teorica)">
                        VER FOTOS
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br>
          <div v-if="loadingPhotos" class="d-flex justify-content-center">
            <component
              :animation-duration="1000"
              :is="'SpringSpinner'"
              :color="'#4AE387'"
              :size="80"
            >
            </component>
          </div>
          <div v-if="fotos.virtual">
            <hr>
              <h2 class="text-center">{{ showing.autoescola }}: {{ showing.agrupamento }}
              <button class="fa fa-refresh btn-micro btn-info" @click="loadPhotos(showing.id_turma_teorica)" title="atulizar fotos"></button></h2>
            <div class="d-flex justify-content-left text-center" v-if="fotos.instrutor" >
              <div class="card" style="width: 17rem;">
                <img class="card-img-top" :src="'data:image/jpeg;base64, ' + fotos.instrutor.perfil" alt="Falha ao carregar imagem">
                <div class="card-body">
                  <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important;">{{ fotos.instrutor.instrutor }}</h5>
                  <button type="button" @click="modalPhotos(fotos.instrutor)" class="btn btn-block btn-lg btn-secondary">FOTOS</button>
                  <!-- <button type="button" @click="modalReport(showing, fotos.instrutor, 'INSTRUTOR')"
                  :disabled="!fotos.instrutor.presencas.find(element => element.tipo == 0)"
                  class="btn btn-block btn-lg btn-danger">REPORTAR</button> -->
                  <span>{{ fotos.instrutor.presencas.find(element => element.tipo == 0) ? "Presença registrada" : "Sem registro de entrada" }}</span>
                </div>
              </div>
              <div class="card d-flex align-self-center" style="width: 18rem;" v-for="arrayFotos in fotos.instrutor.fotos.slice(0,4)" :key="arrayFotos.id_foto_teorica">
                <img class="card-img-top" :src="'data:image/jpeg;base64, ' + arrayFotos.imagem" :title="arrayFotos.tempo" alt="Falha ao carregar imagem">
                <div class="card-body">
                  <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important;">{{ arrayFotos.tempo.split(" ")[1] }}</h5>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-left text-center" v-for="(aluno, index) in fotos.alunos" :key="index">
              <div class="card" style="width: 17rem;">
                <img class="card-img-top" :src="'data:image/jpeg;base64, ' + aluno.perfil" alt="Falha ao carregar imagem">
                <div class="card-body">
                  <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important;">{{ aluno.aluno }}</h5>
                  <button type="button" @click="modalPhotos(aluno)" class="btn btn-block btn-lg btn-secondary">FOTOS</button>
                  <!-- <button type="button" @click="modalReport(showing, aluno, 'ALUNO')"
                  :disabled="!aluno.presencas.find(element => element.tipo == 0)"
                  class="btn btn-block btn-lg btn-danger">REPORTAR</button> -->
                  <span>{{ aluno.presencas.find(element => element.tipo == 0) ? "Presença registrada" : "Sem registro de entrada" }}</span>
                </div>
              </div>
              <div class="card d-flex align-self-center" style="width: 18rem;" v-for="arrayFotos in aluno.fotos.slice(0,4)" :key="arrayFotos.id_foto_teorica">
                <img class="card-img-top" :src="'data:image/jpeg;base64, ' + arrayFotos.imagem" :title="arrayFotos.tempo" alt="Falha ao carregar imagem">
                <div class="card-body">
                  <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important;">{{ arrayFotos.tempo.split(" ")[1] }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center" v-if="typeof(fotos.virtual) !== 'undefined' && !loadingPhotos">
            <hr>
              <h2>{{ showing.autoescola }}: {{ showing.agrupamento }}
              <button class="fa fa-refresh btn-micro btn-info" @click="loadPhotos(showing.id_turma_teorica)" title="atualizar fotos"></button></h2>
              <div class="col-md-12 mb-3 d-flex">
                <!-- <div class="col-md-6">
                  <strong class="font-weight-bold">Monitor</strong>
                  <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.nome }}</span>
                </div> -->
                <div class="col-md-3">
                  <strong class="font-weight-bold">Primeiro registro</strong>
                  <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.inicio | DateBRFilter }}</span>
                </div>
                <div class="col-md-3">
                  <strong class="font-weight-bold">Ultimo registro</strong>
                  <span style="overflow: hidden;" class="input-group-text mt-2">{{ monitor.fim | DateBRFilter }}</span>
                </div>
              </div>
              <button type="button" @click="sendMonitoring(selectedUser)" class="btn btn-lg btn-block btn-primary"
              :disabled="btnNotificacao"
              title="Registrar monitoria">MONITORANDO</button>
              <button type="button" @click="modalReport(showing)" class="btn btn-block btn-lg btn-danger"
              title="Reportar problema">REPORTAR</button>
              <div class="card col" style="width: 18rem;" v-for="arrayFotos in fotos.fotos" :key="arrayFotos.id_foto_teorica">
                <img class="card-img-top" :src="'data:image/jpeg;base64, ' + arrayFotos.imagem" :title="arrayFotos.tempo" alt="Falha ao carregar imagem">
                <div class="card-body">
                  <h5 class="card-title" style="white-space: nowrap; overflow: hidden !important;">{{ arrayFotos.tempo.split(" ")[1] }}</h5>
                </div>
              </div>
            </div>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>
<script>
import TeoricasController from "./TeoricasController";
import { ModelSelect } from "vue-search-select";
import * as spinners from "epic-spinners";
import urlApi from '../../router/urlApiV2'

export default {
  name:'MonitoramentoFotosTeoricas',
  components: {
    ModelSelect,
    ...spinners,
  },
  data() {
    return {
      imageCheck: false,
      imageModal: "image-check",
      selectCFC: [],
      selectedCFC: null,
      showing: [],
      loadTable: false,
      loadingPhotos: false,
      loadedClasses: 0,
      tbTurmas: [],
      fotos: [],
      selectPeriodo: [
        { value: 0, text: "Manhã" },
        { value: 1, text: "Tarde" },
        { value: 2, text: "Noite" },
      ],
      selectedPeriodo: null,
      selectedUser: [],
      report: [],
      monitor: { nome: null, inicio: null, fim: null},
      btnNotificacao: false,
      idNotificacao: null,
      notificacoes: [
        {
          value: 0,
          title: 'Aluno fora de foco',
        },
        {
          value: 1,
          title: 'Tela preta',
        }
      ],
    };
  },
  mounted() {
    TeoricasController.startTime();
    //CARREGAR CFC's
    TeoricasController.loadCfc().then((res) => {
      this.selectCFC = [];
      this.selectCFC = res;
    });
  },
  methods: {
    modalPhotos(photos) {
      this.selectedUser = {
        participante: photos.aluno ? photos.aluno : photos.instrutor,
        cpf:          photos.cpf,
        fotos:        photos.fotos,
        perfil:       photos.perfil,
        presencas:    photos.presencas
      }
      this.getMonitor({ tipo: photos.aluno ? 'ALUNO' : 'INSTRUTOR', cpf: photos.cpf })
      this.$refs.modalPhotos.open()
    },
    abrirSala(sala, schema) {
      TeoricasController.abrirSala(sala, schema);
    },
    loadData() {
      if(this.selectedCFC == null || this.selectedPeriodo == null)
      {
        this.$toasted.show('Necessário informar autoescola e período', {
          position: 'top-right',
        })
        return
      }
      this.loadTable = true;
      this.tbTurmas = [];
      TeoricasController.getAulas( (data) => {
          if (data.dados.length === 0) {
            this.$toasted.show('Nenhuma aula agendada para o período', {
              position: 'top-right',
            })
          }else
          {
            this.tbTurmas = data.dados;
          }
          this.loadTable = false;
        },
        this.selectedCFC,
        this.selectedPeriodo
      );
    },
    loadPhotos(loadPhotos) {
      this.loadingPhotos = true;
      this.fotos = [];
      TeoricasController.getPhotos( (data) => {
        this.fotos  = [];
        this.fotos  = data.dados;
        this.loadingPhotos = false;
        this.showing = { autoescola: this.selectCFC.find(element => element.value == this.selectedCFC).text,
        agrupamento: this.tbTurmas.find(element => element.id_turma_teorica == loadPhotos).id_agrupamento,
        id_turma_teorica: this.tbTurmas.find(element => element.id_turma_teorica == loadPhotos).id_turma_teorica,
        schema:  this.selectCFC.find(element => element.value == this.selectedCFC).value }
      },
        this.selectedCFC,
        loadPhotos
      );
    },
    notificarAluno(cpf) {
      let data = {
        cpf: cpf,
        idNotificacao: this.idNotificacao,
      }
      this.$http.post(urlApi + '/push/notify-student', data).then((response) => {
        console.log(response)
      })
    },
    modalReport(aula, participante = null, tipo = null) {
      this.report = [];
      if(participante === null)
      {
        this.report = {
          autoescola:   aula.autoescola,
          schema:       aula.schema,
          id_turma:     aula.id_turma_teorica,
          agrupamento:  aula.agrupamento,
          tipo_report:  null,
          observacao:   null
        }
        this.getMonitor()
      }else
      {
        this.report = {
          autoescola:   aula.autoescola,
          schema:       aula.schema,
          id_turma:     aula.id_turma_teorica,
          agrupamento:  aula.agrupamento,
          cpf:          participante.cpf,
          tipo:         tipo,
          tipo_report:  null,
          observacao:   null
        }
        this.getMonitor(this.report)
      }
      this.$refs.modalReport.open()
    },
    sendReport(dados) {
      this.btnNotificacao = true
      if(dados.tipo_report == null || dados.observacao == null)
      {
        this.$toasted.show('Necessário selecionar o problema e descrever o que foi feito!', {
          position: 'top-right',
        })
        this.btnNotificacao = false
        return
      }else if(dados.observacao.trim().length < 5)
      {
        this.$toasted.show('Obeservação deve conter no mínimo 5 caracteres!', {
          position: 'top-right',
        })
        this.btnNotificacao = false
        return
      }
      this.$http.post(urlApi + '/aulas/teoricas/notificacao/fotos', dados).then((response) => {
        this.$toasted.show(response.body.mensagem, {
          position: 'top-right',
        })
        this.btnNotificacao = false
        this.getMonitor(dados)
      }).catch((error) => {
        this.btnNotificacao = false
        this.$toasted.show(error.body.mensagem, {
          position: 'top-right',
        })
      })
    },
    sendMonitoring(dados, tipo = null) {
      this.btnNotificacao = true
      let report = {
        autoescola:   this.showing.autoescola,
        schema:       this.showing.schema,
        id_turma:     this.showing.id_turma_teorica,
        agrupamento:  this.showing.agrupamento,
        cpf:          dados.cpf ? dados.cpf : null,
        tipo:         tipo,
        tipo_report:  1,
        observacao:   null
      }
      this.$http.post(urlApi + '/aulas/teoricas/notificacao/fotos', report).then((response) => {
        this.$toasted.show(response.body.mensagem, {
          position: 'top-right',
        })
        this.btnNotificacao = false
        this.getMonitor(report)
      }).catch((error) => {
        this.btnNotificacao = false
        this.$toasted.show(error.body.mensagem, {
          position: 'top-right',
        })
      })
    },
    getMonitor(participante = null)
    {
      this.monitor  = {
        nome: 'carregando os dados . . .',
        inicio: '...',
        fim:  '...'
      }

      let $param  = participante !== null  ?
        `schema=${this.showing.schema}&turma=${this.showing.id_turma_teorica}&entidade=${participante.tipo}&cpf=${participante.cpf}`  :
        `schema=${this.showing.schema}&turma=${this.showing.id_turma_teorica}`;
      this.$http.get(urlApi + `/aulas/teoricas/notificacao/consultar/monitor?${$param}`).then((response) => {
        if(response.body.dados == null)
        {
          this.monitor  = {
            nome:   'Sem registro de monitoria',
            inicio: 'xx:xx:xx',
            fim:    'xx:xx:xx'
          }
          return
        }
        this.monitor  = {
          nome: response.body.dados.usuario.nome,
          inicio: response.body.dados.notificacoes[0].created_at,
          fim:  response.body.dados.notificacoes[response.body.dados.notificacoes.length - 1].created_at
        };
      }).catch((error) => {
        this.$toasted.show(error.body.mensagem, {
          position: 'top-right',
        })
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.centralizado {
  text-align: center;
}
.avatar {
  position: relative;
}

.teste:hover {
  top: -2px;
  box-shadow: 0 2px 2px #666;
}

.aula {
  border: rgb(134, 129, 129) solid 2px;
  border-radius: 2%;
}
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px; /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 200px;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}

#monitoramentoFotosTeoricas {
  #modalPhotos {
    .badge {
      cursor: default;
      font-size: 20px;
      padding: 10px 20px;
      background-color: rgb(88, 88, 88) !important;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.9s ease;
      overflow: hidden;
      visibility: visible;
      position: absolute;
      width: 100%;
      opacity: 1;
    }

    .fade-enter,
    .fade-leave-to {
      visibility: hidden;
      width: 100%;
      opacity: 0;
    }

    .fa-low-vision {
      font-size: 30px;
      color: white;
      background-color: #dc3545;
      border-color: #dc3545;
      padding: 15px 15px;
      border-radius: 50%;
      box-shadow: black;
      cursor: pointer;
    }

    .fa-low-vision:hover {
      background-color: #dc35467a;
    }

    .modal-lg div.modal-footer
    {
      display: none !important;
    }
  }
}
</style>
